<template>
    <v-app id="inspire">
        <v-navigation-drawer 
          v-model="drawer"
          color="#FFFFFF"
          app
        >
          <Navigation></Navigation>

          <template v-slot:append>
            <div class="pa-2">
              <v-btn
                type="submit" 
                @click="logOut()"
                block
                color="#6d6e71"
                dark
              >
                Logout
              </v-btn>
            </div>
          </template>
        </v-navigation-drawer>
        <v-app-bar 
          app
          color="#004236"
        >
          <v-app-bar-nav-icon @click="drawer = !drawer" color="white"></v-app-bar-nav-icon>
          <v-toolbar-title>
            <span>CUPE Application Portal</span>
          </v-toolbar-title>
        </v-app-bar>

        <v-main>
            <router-view></router-view>
        </v-main>
    </v-app>
</template>
  
<script>
import Navigation from "../../components/Applicants/Navigation.vue"

import firebase from 'firebase'
require('firebase/auth')

export default {
    name: "ApplicantApp",
    components: {
      Navigation
    },
    data(){
        return {
            drawer: null
        }
    },
    methods: {
        logOut() {
            firebase.auth().signOut().then(() => {
                firebase.auth().onAuthStateChanged(() => {
                    this.$router.push('/signin')
                    sessionStorage.clear();
                })
            });
        }
    }
}
</script>

<style scoped>
span{
    color: white;
}
</style>